(function () {
  'use strict';

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function readJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function clampQuantity(value) {
    var number = Number(value || 1);
    if (!Number.isFinite(number)) number = 1;
    return Math.max(1, Math.min(20, Math.round(number)));
  }

  function getRoot(root) {
    var value = root || '/';
    return value.endsWith('/') ? value : value + '/';
  }

  function initBuilder(section) {
    if (!section || section.dataset.noveraPbReady === 'true') return;
    section.dataset.noveraPbReady = 'true';

    var config = readJson(section.querySelector('[data-sspb-config]'));
    if (!config) return;

    var variants = Array.isArray(config.variants) ? config.variants : [];
    var initialId = Number(config.initialVariantId || 0);
    var selectedVariant = variants.find(function (variant) {
      return Number(variant.id) === initialId;
    }) || variants.find(function (variant) {
      return variant.available;
    }) || variants[0] || null;

    var selectedQuantity = 1;
    var selectedPlan = 0;
    var selectedDiscountCents = 0;
    var selectedCustomTotalCents = 0;

    var priceNode = section.querySelector('[data-sspb-price]');
    var compareNode = section.querySelector('[data-sspb-compare]');
    var saleNode = section.querySelector('[data-sspb-sale]');
    var addButton = section.querySelector('[data-sspb-add]');
    var addLabel = section.querySelector('[data-sspb-add-label]');
    var form = addButton ? addButton.closest('form') : null;
    var formVariant = section.querySelector('[data-sspb-form-variant]');
    var formQty = section.querySelector('[data-sspb-form-qty]');
    var statusNode = section.querySelector('[data-sspb-status]');
    var inventoryNode = section.querySelector('[data-sspb-inventory]');
    var inventoryText = section.querySelector('[data-sspb-inventory-text]');
    var whatsapp = section.querySelector('[data-sspb-whatsapp]');
    var sticky = section.querySelector('[data-sspb-sticky]');
    var stickyButton = section.querySelector('[data-sspb-sticky-add]');
    var stickyPrice = section.querySelector('[data-sspb-sticky-price]');
    var buyZone = section.querySelector('[data-sspb-buy-zone]');

    function setStatus(message, isError) {
      if (!statusNode) return;
      statusNode.textContent = message || '';
      statusNode.style.color = isError ? 'var(--sspb-danger)' : 'var(--sspb-success)';
    }

    function setMainLoading(loading) {
      if (addButton) {
        addButton.classList.toggle('is-loading', loading);
        addButton.disabled = loading || !(selectedVariant && selectedVariant.available);
      }
      if (stickyButton) {
        stickyButton.disabled = loading || !(selectedVariant && selectedVariant.available);
        if (loading) stickyButton.textContent = 'ADDING...';
      }
      if (loading && addLabel) addLabel.textContent = 'ADDING...';
      if (!loading) updatePurchaseUI();
    }

    function currentPrice() {
      return selectedVariant ? Number(selectedVariant.price || 0) : 0;
    }

    function updatePurchaseUI() {
      var price = currentPrice();
      var available = Boolean(selectedVariant && selectedVariant.available);
      var calculatedTotal = Math.max(0, (price * selectedQuantity) - selectedDiscountCents);
      var selectedTotal = selectedCustomTotalCents > 0 ? selectedCustomTotalCents : calculatedTotal;

      if (priceNode) priceNode.textContent = money(price, config.currency);

      if (compareNode) {
        var compare = selectedVariant ? Number(selectedVariant.compareAtPrice || 0) : 0;
        if (compare > price) {
          compareNode.textContent = money(compare, config.currency);
          compareNode.classList.remove('is-hidden');
        } else {
          compareNode.textContent = '';
          compareNode.classList.add('is-hidden');
        }
      }

      if (saleNode) {
        var compareForSale = selectedVariant ? Number(selectedVariant.compareAtPrice || 0) : 0;
        saleNode.classList.toggle('is-hidden', !(compareForSale > price));
      }

      if (formVariant) formVariant.value = selectedVariant ? String(selectedVariant.id) : '';
      if (formQty) formQty.value = String(selectedQuantity);

      if (addButton) addButton.disabled = !available;
      if (addLabel) {
        addLabel.textContent = available
          ? ((addButton && addButton.dataset.buttonLabel) || 'ADD TO CART') + ' • ' + money(selectedTotal, config.currency)
          : 'SOLD OUT';
      }

      if (stickyButton) stickyButton.disabled = !available;
      if (stickyPrice) stickyPrice.textContent = money(selectedTotal, config.currency);
      updateOfferPrices();

      updateInventory();
      updateWhatsapp();
      updateFbtMain();
    }

    function updateInventory() {
      if (!inventoryNode) return;
      if (!selectedVariant) {
        inventoryNode.classList.add('is-hidden');
        return;
      }

      var management = selectedVariant.inventoryManagement;
      var quantity = Number(selectedVariant.inventoryQuantity || 0);
      var threshold = Number(inventoryNode.dataset.threshold || 8);
      var shouldShow = Boolean(management) && quantity > 0 && quantity <= threshold;

      inventoryNode.classList.toggle('is-hidden', !shouldShow);
      if (shouldShow && inventoryText) {
        var template = inventoryText.dataset.template || inventoryText.textContent || 'Only {count} left in stock';
        if (!inventoryText.dataset.template) inventoryText.dataset.template = template;
        inventoryText.textContent = template.replace('{count}', String(quantity));
      }
    }

    function updateWhatsapp() {
      if (!whatsapp || !selectedVariant) return;
      var number = whatsapp.dataset.number || '';
      if (!number) return;
      var template = whatsapp.dataset.message || 'Hi Novera, I have a question about {product}.';
      var message = template
        .replace('{product}', config.productTitle || 'this product')
        .replace('{variant}', selectedVariant.title || '')
        .replace('{price}', money(selectedVariant.price, config.currency));
      whatsapp.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    }

    var optionGroups = Array.from(section.querySelectorAll('[data-sspb-option-group]'));
    var optionButtons = Array.from(section.querySelectorAll('[data-sspb-option-value]'));

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var selected = group.querySelector('[data-sspb-option-value].is-selected');
        return selected ? selected.dataset.value : '';
      });
    }

    function variantMatchesOptions(variant, values) {
      if (!variant || !Array.isArray(variant.options) || variant.options.length !== values.length) return false;
      return values.every(function (value, index) {
        return variant.options[index] === value;
      });
    }

    function findSelectedVariant() {
      if (!optionGroups.length) return selectedVariant;
      var values = selectedOptions();
      return variants.find(function (variant) {
        return variantMatchesOptions(variant, values);
      }) || null;
    }

    function updateVariantPillAvailability() {
      if (!optionGroups.length) return;
      var current = selectedOptions();

      optionButtons.forEach(function (button) {
        var optionIndex = Number(button.dataset.optionIndex || 0);
        var candidate = current.slice();
        candidate[optionIndex] = button.dataset.value || '';
        var possible = variants.some(function (variant) {
          if (!variant.available) return false;
          return candidate.every(function (value, index) {
            if (index === optionIndex) return variant.options[index] === value;
            return !value || variant.options[index] === value;
          });
        });
        button.disabled = !possible && !button.classList.contains('is-selected');
      });
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var group = button.closest('[data-sspb-option-group]');
        if (!group) return;
        group.querySelectorAll('[data-sspb-option-value]').forEach(function (other) {
          var active = other === button;
          other.classList.toggle('is-selected', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        selectedVariant = findSelectedVariant();
        updateVariantPillAvailability();
        showVariantMedia();
        updatePurchaseUI();
      });
    });

    var qtyInput = section.querySelector('[data-sspb-qty-input]');
    var qtyMinus = section.querySelector('[data-sspb-qty-minus]');
    var qtyPlus = section.querySelector('[data-sspb-qty-plus]');
    var offersWrap = section.querySelector('[data-sspb-offers]');
    var offerButtons = Array.from(section.querySelectorAll('[data-sspb-offer]'));

    function updateOfferPrices() {
      if (!offerButtons.length) return;
      var base = currentPrice();

      offerButtons.forEach(function (button) {
        var qty = clampQuantity(button.dataset.quantity || 1);
        var discount = Math.max(0, Number(button.dataset.discountCents || 0));
        var customTotal = Math.max(0, Number(button.dataset.customTotalCents || 0));
        var calculatedTotal = Math.max(0, (base * qty) - discount);
        var total = customTotal > 0 ? customTotal : calculatedTotal;
        var priceNode = button.querySelector('[data-sspb-offer-price]');
        var perUnitNode = button.querySelector('[data-sspb-per-unit]');

        if (priceNode) priceNode.textContent = money(total, config.currency);
        if (perUnitNode) perUnitNode.textContent = money(total / qty, config.currency) + ' each';
      });
    }

    function clearOffers() {
      selectedPlan = 0;
      selectedDiscountCents = 0;
      selectedCustomTotalCents = 0;
      offerButtons.forEach(function (button) {
        button.classList.remove('is-selected');
        button.setAttribute('aria-checked', 'false');
      });
    }

    function setQuantity(value, preserveOffer) {
      selectedQuantity = clampQuantity(value);
      if (!preserveOffer) clearOffers();
      if (qtyInput) qtyInput.value = String(selectedQuantity);
      updatePurchaseUI();
    }

    function selectOffer(button) {
      if (!button) return;
      selectedPlan = Number(button.dataset.plan || 1);
      selectedQuantity = clampQuantity(button.dataset.quantity || selectedPlan || 1);
      selectedDiscountCents = Math.max(0, Number(button.dataset.discountCents || 0));
      selectedCustomTotalCents = Math.max(0, Number(button.dataset.customTotalCents || 0));

      offerButtons.forEach(function (offer) {
        var active = offer === button;
        offer.classList.toggle('is-selected', active);
        offer.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (qtyInput) qtyInput.value = String(selectedQuantity);
      updatePurchaseUI();
    }

    offerButtons.forEach(function (button) {
      button.addEventListener('click', function () { selectOffer(button); });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        var index = offerButtons.indexOf(button);
        var nextIndex = event.key === 'ArrowDown'
          ? (index + 1) % offerButtons.length
          : (index - 1 + offerButtons.length) % offerButtons.length;
        offerButtons[nextIndex].focus();
        selectOffer(offerButtons[nextIndex]);
      });
    });

    if (offerButtons.length) {
      var defaultPlan = offersWrap ? String(offersWrap.dataset.defaultPlan || '1') : '1';
      var initialOffer = offerButtons.find(function (button) {
        return String(button.dataset.plan || '') === defaultPlan;
      }) || offerButtons.find(function (button) { return button.classList.contains('is-selected'); }) || offerButtons[0];
      selectOffer(initialOffer);
    }

    if (qtyMinus) qtyMinus.addEventListener('click', function () { setQuantity(selectedQuantity - 1, false); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { setQuantity(selectedQuantity + 1, false); });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { setQuantity(qtyInput.value, false); });
      qtyInput.addEventListener('blur', function () { setQuantity(qtyInput.value, false); });
    }

    var slides = Array.from(section.querySelectorAll('[data-sspb-slide]'));
    var thumbs = Array.from(section.querySelectorAll('[data-sspb-thumb]'));
    var countNode = section.querySelector('[data-sspb-count]');
    var currentSlide = 0;

    function showSlide(index) {
      if (!slides.length) return;
      currentSlide = (index + slides.length) % slides.length;

      slides.forEach(function (slide, idx) {
        var active = idx === currentSlide;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) {
          slide.querySelectorAll('video').forEach(function (video) {
            try { video.pause(); } catch (error) {}
          });
        }
      });

      thumbs.forEach(function (thumb, idx) {
        var active = idx === currentSlide;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
        }
      });

      if (countNode) countNode.textContent = (currentSlide + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(Number(thumb.dataset.index || 0));
      });
    });

    var prev = section.querySelector('[data-sspb-prev]');
    var next = section.querySelector('[data-sspb-next]');
    if (prev) prev.addEventListener('click', function () { showSlide(currentSlide - 1); });
    if (next) next.addEventListener('click', function () { showSlide(currentSlide + 1); });

    var mainMedia = section.querySelector('.novera-pb__main-media');
    var touchStartX = null;
    if (mainMedia) {
      mainMedia.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
      }, { passive: true });
      mainMedia.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
        var diff = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(diff) < 42) return;
        showSlide(currentSlide + (diff < 0 ? 1 : -1));
      }, { passive: true });
    }

    function showVariantMedia() {
      if (config.gallerySource !== 'product') return;
      if (!selectedVariant || !selectedVariant.featuredMediaId) return;
      var mediaId = String(selectedVariant.featuredMediaId);
      var index = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId || '') === mediaId;
      });
      if (index >= 0) showSlide(index);
    }

    async function directAdd(items) {
      var root = getRoot(config.routesRoot);
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      var data = await response.json().catch(function () { return null; });
      if (!response.ok) {
        throw new Error((data && (data.description || data.message)) || 'Unable to add this item.');
      }
      return data;
    }

    async function refreshAndOpenNoveraCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.NoveraCart) {
        try {
          if (typeof window.NoveraCart.refresh === 'function') await window.NoveraCart.refresh();
          if (typeof window.NoveraCart.open === 'function') await window.NoveraCart.open();
        } catch (error) {}
      }
    }

    async function addMainToCart() {
      if (!selectedVariant || !selectedVariant.available) return;
      setStatus('');
      setMainLoading(true);

      try {
        if (window.NoveraCart && typeof window.NoveraCart.add === 'function') {
          await window.NoveraCart.add(Number(selectedVariant.id), selectedQuantity, {});
        } else {
          await directAdd([{ id: Number(selectedVariant.id), quantity: selectedQuantity }]);
          await refreshAndOpenNoveraCart();
        }
        setStatus('Added to cart.');
        window.setTimeout(function () { setStatus(''); }, 1800);
      } catch (error) {
        setStatus(error.message || 'Unable to add this item. Please try again.', true);
      } finally {
        setMainLoading(false);
      }
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addMainToCart();
      });
    }
    if (stickyButton) stickyButton.addEventListener('click', addMainToCart);

    var fbtBlocks = Array.from(section.querySelectorAll('[data-sspb-fbt]'));

    function visualDiscount(total, type, value) {
      var number = Number(value || 0);
      if (type === 'percent' && number > 0) return Math.max(0, total - Math.round(total * (number / 100)));
      if (type === 'fixed' && number > 0) return Math.max(0, total - Math.round(number * 100));
      return total;
    }

    function initFbt(block) {
      if (!block || block.dataset.sspbFbtReady === 'true') return;
      block.dataset.sspbFbtReady = 'true';

      var fbtConfig = readJson(block.querySelector('[data-sspb-fbt-config]'));
      if (!fbtConfig) return;
      var companionVariants = Array.isArray(fbtConfig.variants) ? fbtConfig.variants : [];
      var companionVariant = companionVariants.find(function (variant) {
        return Number(variant.id) === Number(fbtConfig.initialVariantId || 0);
      }) || companionVariants.find(function (variant) { return variant.available; }) || companionVariants[0] || null;

      var optionSelects = Array.from(block.querySelectorAll('[data-sspb-fbt-option]'));
      var mainPriceNode = block.querySelector('[data-sspb-fbt-main-price]');
      var mainVariantNode = block.querySelector('[data-sspb-fbt-main-variant]');
      var compPriceNode = block.querySelector('[data-sspb-fbt-comp-price]');
      var totalNode = block.querySelector('[data-sspb-fbt-total]');
      var originalNode = block.querySelector('[data-sspb-fbt-original]');
      var noteNode = block.querySelector('[data-sspb-fbt-discount-note]');
      var fbtButton = block.querySelector('[data-sspb-fbt-add]');
      var fbtStatus = block.querySelector('[data-sspb-fbt-status]');

      function selectedCompanionOptions() {
        return optionSelects.map(function (select) { return select.value; });
      }

      function findCompanionVariant() {
        if (!optionSelects.length) return companionVariant;
        var values = selectedCompanionOptions();
        return companionVariants.find(function (variant) {
          return Array.isArray(variant.options) && variant.options.length === values.length &&
            variant.options.every(function (value, index) { return value === values[index]; });
        }) || null;
      }

      function updateFbt() {
        var mainAvailable = Boolean(selectedVariant && selectedVariant.available);
        var companionAvailable = Boolean(companionVariant && companionVariant.available);
        var mainPrice = selectedVariant ? Number(selectedVariant.price || 0) : 0;
        var companionPrice = companionVariant ? Number(companionVariant.price || 0) : 0;
        var rawTotal = mainPrice + companionPrice;
        var discountType = block.dataset.discountType || 'none';
        var discountValue = Number(block.dataset.discountValue || 0);
        var discounted = visualDiscount(rawTotal, discountType, discountValue);
        var code = (block.dataset.discountCode || '').trim();

        if (mainPriceNode) mainPriceNode.textContent = money(mainPrice, config.currency);
        if (mainVariantNode) {
          var mainVariantTitle = selectedVariant ? (selectedVariant.title || '') : '';
          mainVariantNode.textContent = mainVariantTitle === 'Default Title' ? '' : mainVariantTitle;
          mainVariantNode.classList.toggle('is-hidden', !mainVariantNode.textContent);
        }
        if (compPriceNode) compPriceNode.textContent = money(companionPrice, config.currency);

        if (totalNode) totalNode.textContent = money(discounted, config.currency);

        if (originalNode) {
          var showOriginal = discounted < rawTotal;
          originalNode.classList.toggle('is-hidden', !showOriginal);
          originalNode.textContent = showOriginal ? money(rawTotal, config.currency) : '';
        }

        if (noteNode) {
          var showNote = Boolean(code);
          noteNode.classList.toggle('is-hidden', !showNote);
          noteNode.textContent = showNote
            ? (discounted < rawTotal ? 'Estimated after code ' + code + '. Shopify confirms the final discount at checkout.' : 'Code ' + code + ' will be confirmed by Shopify at checkout.')
            : '';
        }

        if (fbtButton) fbtButton.disabled = !(mainAvailable && companionAvailable);
      }

      function setFbtStatus(message, isError) {
        if (!fbtStatus) return;
        fbtStatus.textContent = message || '';
        fbtStatus.style.color = isError ? 'var(--sspb-danger)' : 'var(--sspb-success)';
      }

      function setFbtLoading(loading) {
        if (!fbtButton) return;
        fbtButton.classList.toggle('is-loading', loading);
        fbtButton.disabled = loading || !(selectedVariant && selectedVariant.available && companionVariant && companionVariant.available);
        var label = fbtButton.querySelector('span');
        if (label) label.textContent = loading ? 'ADDING BOTH...' : (block.dataset.buttonLabel || 'ADD BOTH TO CART');
      }

      optionSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          companionVariant = findCompanionVariant();
          updateFbt();
        });
      });

      if (fbtButton) {
        fbtButton.addEventListener('click', async function () {
          if (!selectedVariant || !selectedVariant.available || !companionVariant || !companionVariant.available) return;
          setFbtStatus('');
          setFbtLoading(true);
          try {
            await directAdd([
              { id: Number(selectedVariant.id), quantity: 1 },
              { id: Number(companionVariant.id), quantity: 1 }
            ]);
            await refreshAndOpenNoveraCart();

            var code = (block.dataset.discountCode || '').trim();
            if (code) {
              window.setTimeout(function () {
                var input = document.querySelector('[data-discount-code]');
                var apply = document.querySelector('[data-discount-apply]');
                if (input) input.value = code;
                if (apply) {
                  try { apply.click(); } catch (error) {}
                }
              }, 120);
            }

            setFbtStatus('Both products added to cart.');
            window.setTimeout(function () { setFbtStatus(''); }, 2200);
          } catch (error) {
            setFbtStatus(error.message || 'Unable to add both products. Please try again.', true);
          } finally {
            setFbtLoading(false);
          }
        });
      }

      block._noveraUpdateFbt = updateFbt;
      updateFbt();
    }

    fbtBlocks.forEach(initFbt);

    function updateFbtMain() {
      if (!fbtBlocks) return;
      fbtBlocks.forEach(function (block) {
        if (typeof block._noveraUpdateFbt === 'function') block._noveraUpdateFbt();
      });
    }

    var accordions = Array.from(section.querySelectorAll('[data-sspb-accordion]'));

    function openAccordion(item) {
      var toggle = item.querySelector('[data-sspb-accordion-toggle]');
      var panel = item.querySelector('[data-sspb-accordion-panel]');
      if (!toggle || !panel) return;
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    function closeAccordion(item) {
      var toggle = item.querySelector('[data-sspb-accordion-toggle]');
      var panel = item.querySelector('[data-sspb-accordion-panel]');
      if (!toggle || !panel) return;
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('is-open');
      panel.style.maxHeight = '0px';
    }

    accordions.forEach(function (item) {
      var toggle = item.querySelector('[data-sspb-accordion-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        accordions.forEach(function (other) {
          if (other !== item) closeAccordion(other);
        });
        if (isOpen) closeAccordion(item);
        else openAccordion(item);
      });
      closeAccordion(item);
    });

    var zoomModal = section.querySelector('[data-sspb-zoom-modal]');
    var zoomImage = section.querySelector('[data-sspb-zoom-image]');
    var zoomClose = section.querySelector('[data-sspb-zoom-close]');

    function openZoom(src) {
      if (!zoomModal || !zoomImage || !src) return;
      zoomImage.src = src;
      zoomModal.classList.add('is-open');
      zoomModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('novera-pb-zoom-open');
      if (zoomClose) zoomClose.focus();
    }

    function closeZoom() {
      if (!zoomModal || !zoomImage) return;
      zoomModal.classList.remove('is-open');
      zoomModal.setAttribute('aria-hidden', 'true');
      zoomImage.removeAttribute('src');
      document.body.classList.remove('novera-pb-zoom-open');
    }

    section.querySelectorAll('[data-sspb-zoom]').forEach(function (button) {
      button.addEventListener('click', function () {
        openZoom(button.dataset.zoomSrc || '');
      });
    });
    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    if (zoomModal) {
      zoomModal.addEventListener('click', function (event) {
        if (event.target === zoomModal || event.target.classList.contains('novera-pb__zoom-stage')) closeZoom();
      });
    }

    function escapeHandler(event) {
      if (event.key === 'Escape' && zoomModal && zoomModal.classList.contains('is-open')) closeZoom();
    }
    document.addEventListener('keydown', escapeHandler);

    function cartOrMenuOpen() {
      return document.body.classList.contains('novera-panel-open') ||
        document.body.classList.contains('novera-cart-open') ||
        document.body.classList.contains('menu-open') ||
        Boolean(document.querySelector(
          '[data-cart-drawer].is-active, .novera-cart-drawer.is-active, ' +
          '[data-mobile-menu].is-active, .novera-mobile-menu.is-active, ' +
          '[data-search-modal].is-active, .novera-search-modal.is-active'
        ));
    }

    function updateSticky() {
      if (!sticky || !buyZone) return;
      var rect = buyZone.getBoundingClientRect();
      var shouldShow = rect.bottom < 0 && !cartOrMenuOpen();
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    if (sticky && buyZone) {
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      var bodyObserver = new MutationObserver(updateSticky);
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('cart:updated', updateSticky);
      updateSticky();
    }

    window.addEventListener('resize', function () {
      accordions.forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        var panel = item.querySelector('[data-sspb-accordion-panel]');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    }, { passive: true });

    updateVariantPillAvailability();
    showVariantMedia();
    updatePurchaseUI();
    showSlide(0);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-novera-product-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
